import {
    faChevronLeft,
    faCommentDots,
    faPaperclip,
    faTimes,
} from "@fortawesome/free-solid-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { ClickAwayListener } from "@material-ui/core";
import { useEffect, useState } from "react";
import { OverlayTrigger, Tooltip } from "react-bootstrap";
import { useForm } from "react-hook-form";
import { useAtedimento } from "../../../../../Context/Atendimento";
import { useUserInfor } from "../../../../../Context/User";
import { EnviarMensagemController } from "../../../../../Controllers/HelpDesk/Atendimento/AtendimentoControllers";
import {
    ListarCategoriasRespostaChatController,
    ListarRespostaChatController,
} from "../../../../../Controllers/HelpDesk/GestaoRespostas/GestaoRespostasControllers";
import useAsyncCallback from "../../../../../hooks/useAsyncCallback";
import { ICategiraRespostaCompleto } from "../../../../../Interfaces/HelpDesk/GestaoRespostas/GestaoRespostasInterface";
import { IMensagem } from "../../../../../Interfaces/HelpDesk/Equipes/Atendimento/AtendimentoInterfaces";
import { onValue, off } from "firebase/database";
import { getConversaRef } from "../../../../../Services/Config/ConfigFirebase";
import SimpleRecorder from "../AudioRecorder";
interface IEnviarMensagemProps {}
interface IEnviarMensagem {
    mensagem: string;
}
export default function EnviarMensagem(props: IEnviarMensagemProps) {
    const { register, handleSubmit, reset, setValue } =
        useForm<IEnviarMensagem>();
    const [file, setFile] = useState<File | null>(null);
    const [fileAudio, setFileAudio] = useState<File | null>(null);
    const [showMensage, setshowMensage] = useState(false);
    const [lstCategoriaRespostaCompleta, setLstCategoriaRespostaCompleta] =
        useState<Array<ICategiraRespostaCompleto>>([]);
    // const [lstCategoriaRespostaPreenchida, setlstCategoriaRespostaPreenchida] =
    //     useState<Array<ICategiraRespostaCompleto>>([]);
    const { chatAberto, equipe } = useAtedimento().HELP_DESK;
    const { UserInfor, OrgInfor, Config } = useUserInfor();
    const uploadingFileThatDoesntSupportSubtitles = Boolean(
        file &&
            file.type.split("/")[0] !== "image" &&
            file.type.split("/")[0] !== "video"
    );
    const uploadingFileAudioThatDoesntSupportSubtitles = Boolean(fileAudio);
    const [mensagens, setMensagens] = useState<Array<IMensagem>>([]);
    // Cliente
    const ultimasMensagemCliente = mensagens.filter(
        (msg) => msg.MensagemCliente
    );
    const ultimaMensagemEnviadaCliente =
        ultimasMensagemCliente[ultimasMensagemCliente.length - 1];
    // Equipe
    const ultimasMensagemEquipe = mensagens.filter(
        (msg) => !msg.MensagemCliente
    );
    const primeiraMsgEquipe = mensagens.find((msg) => !msg.MensagemCliente);
    const timestampEquipe = primeiraMsgEquipe?.TimeStamp;
    const ultimaMensagemEnviadaEquipe =
        ultimasMensagemEquipe[ultimasMensagemEquipe.length - 1];
    const ultimaMensagemeEquipe = mensagens[mensagens.length - 1];
    const ultimaMensagemDaEquipe =
        ultimaMensagemeEquipe?.MensagemCliente === false;
    const mensagemDoClienteDepoisDaMensagemEquipe =
        ultimaMensagemEnviadaCliente?.TimeStamp >
        ultimaMensagemEnviadaEquipe?.TimeStamp;
    // Comparação Timestamp entre CLIENTE e EQUIPE
    const diferencaHorasEquipe =
        (Number(new Date(timestampEquipe ?? 0)) - Number(new Date())) /
        (1000 * 60 * 60);
    const mensagemClienteDepoisDe24Horas = diferencaHorasEquipe < -24;
    const timestampUltimaMensagemCliente =
        ultimaMensagemEnviadaCliente?.TimeStamp;
    const diferencaHorasUltimaMensagemCliente =
        (Number(new Date()) -
            Number(new Date(timestampUltimaMensagemCliente))) /
        (1000 * 60 * 60);
    const mensagemClienteEnviadaNasUltimas24Horas =
        diferencaHorasUltimaMensagemCliente > 24;

    const turno =
        new Date().getHours() < 12
            ? "dia"
            : new Date().getHours() >= 19
            ? "noite"
            : "tarde";

    useEffect(() => {
        if (chatAberto && equipe.NR_TELEFONE) {
            setMensagens([]);
            const mensagensRef = getConversaRef(
                OrgInfor.ID_ORGANIZACAO,
                equipe.NR_TELEFONE,
                chatAberto.NumeroCliente
            );
            onValue(mensagensRef, (snap) => {
                const mensagensArray: Array<IMensagem> = [];
                snap.forEach((childSnap) => {
                    mensagensArray.push(childSnap.val());
                });
                setMensagens(mensagensArray);
            });
        } else {
            setMensagens([]);
        }
        return function cleanup() {
            if (chatAberto && equipe.NR_TELEFONE) {
                off(
                    getConversaRef(
                        OrgInfor.ID_ORGANIZACAO,
                        equipe.NR_TELEFONE,
                        chatAberto.NumeroCliente
                    )
                );
            }
        };
    }, [OrgInfor.ID_ORGANIZACAO, chatAberto, equipe.NR_TELEFONE]);
    const { execute: handleMessageSubmit, loading: enviando } =
        useAsyncCallback(async (formData: IEnviarMensagem) => {
            let validFileOrAudio: File | undefined = undefined;
            if (file) {
                validFileOrAudio = file ?? undefined;
            } else {
                validFileOrAudio = fileAudio ?? undefined;
            }
            if (chatAberto && (formData.mensagem || validFileOrAudio)) {
                await EnviarMensagemController({
                    numDestino: chatAberto.NumeroCliente,
                    numOrigem: chatAberto.NumeroAtendente,
                    strMensagem:
                        uploadingFileThatDoesntSupportSubtitles ||
                        uploadingFileAudioThatDoesntSupportSubtitles
                            ? ""
                            : formData.mensagem,
                    File: validFileOrAudio,
                }).then(() => {
                    reset(
                        uploadingFileThatDoesntSupportSubtitles ||
                            uploadingFileAudioThatDoesntSupportSubtitles
                            ? {
                                  mensagem: formData.mensagem,
                              }
                            : undefined
                    );
                    setFile(null);
                    setFileAudio(null);
                });
            }
        });
    useEffect(() => {
        reset();
        setFile(null);
        setFileAudio(null);
    }, [chatAberto, reset]);
    useEffect(() => {
        ListarCategoriasRespostaChatController().then((res) => {
            const categoriasCompletas = [] as Array<ICategiraRespostaCompleto>;
            Promise.all(
                res.map(async (categoria) => {
                    await ListarRespostaChatController(
                        categoria.ID_CATEGORIA_RESPOSTA_CHAT
                    ).then((respostas) => {
                        categoriasCompletas.push({
                            ...categoria,
                            Respostas: respostas,
                        });
                    });
                })
            ).then(() => {
                setLstCategoriaRespostaCompleta(categoriasCompletas);
            });
        });
    }, []);

    /**
     *  Função de substituir variaveis do template de mensagem.
     *  Foi retirado o UseEffect que preenchia as variaveis de template
     *  da mensagem na lista lstCategoriaRespostaPreenchida, já que
     *  removia as tags [[DS_NOME_CLIENTE]] pois carregava quando a tela
     *  de atendimentos carregasse e o chatAberto fosse undefined, sendo
     *  assim sempre substituindo o valor por uma string vazia. Além disso
     *  para evitar que essa tag seja substituida somente uma vez e reescreva
     *  a lista lstCategoriaRespostaPreenchida com isso o nome do primeiro
     *  cliente chat aberto na página apareceria no template de mensagem de
     *  todos os demais chats, foi verificado que a melhor abordagem para
     *  manter o comportamento correto dessa substituição de variaveis seria
     *  usar uma função normal com o comportamento desejado ao inves do useEffect.
     *
     * @param mensagem  template de mensagem com tags a serem substituidas
     * @returns  mensagem de template com variaveis substituidas
     */
    function preencherVariaveisTemplateMensagem(mensagem: string): string {
        return mensagem
            .replace("[[DS_NOME]]", UserInfor.DS_NOME || "")
            .replace(
                "[[DS_NOME_CLIENTE]]",
                chatAberto?.NomeContatoCliente || chatAberto?.ProfileName || ""
            )
            .replace(
                "[[DS_EQUIPE_HELP_DESK]]",
                equipe.DS_EQUIPE_HELP_DESK || ""
            )
            .replace(
                "[[SAUDAÇÕES]]",
                `${turno === "dia" ? "Bom" : "Boa"} ${turno}`
            );
    }

    function sendAutoMessage(messageType: string) {
        let mensagem = messageType;
        //const turno = new Date().getHours() < 12 ? 'dia' : new Date().getHours() >= 19 ? 'noite' : 'tarde' ;
        setValue("mensagem", mensagem);
        document.getElementById("mensagem-input")?.focus();
    }
    const saveFileAudio = (e: any) => {
        const blob = new Blob([e], { type: e.type });
        const nomeDoArquivo = `${e.size}.opus`;
        const fileAudioGravado = new File([blob], nomeDoArquivo, {
            type: e.type,
        });
        setFileAudio(fileAudioGravado);
    };
    return (
        <>
            <form
                onSubmit={handleSubmit(handleMessageSubmit)}
                className="py-4 px-10 align-items-center border-top "
            >
                {chatAberto && (
                    <>
                        <div className="d-flex">
                            {ultimaMensagemDaEquipe &&
                            mensagemClienteDepoisDe24Horas &&
                            mensagemClienteEnviadaNasUltimas24Horas ? (
                                <div
                                    className={`form-control border-0 p-0 mb-4 ${
                                        uploadingFileThatDoesntSupportSubtitles ||
                                        uploadingFileAudioThatDoesntSupportSubtitles
                                            ? "bg-gray-100"
                                            : ""
                                    }`}
                                >
                                    <span>
                                        Devido aos requisitos de sessão do
                                        WhatsApp será necessário esperar o
                                        cliente responder a mensagem para poder
                                        seguir a conversa.
                                    </span>
                                </div>
                            ) : mensagemClienteDepoisDe24Horas &&
                              mensagemClienteEnviadaNasUltimas24Horas ? (
                                <div
                                    className={`form-control border-0 p-0 mb-4 ${
                                        uploadingFileThatDoesntSupportSubtitles ||
                                        uploadingFileAudioThatDoesntSupportSubtitles
                                            ? "bg-gray-100"
                                            : ""
                                    }`}
                                >
                                    <span>
                                        Infelizmente já passaram 24 horas desde
                                        a primeira mensagem do cliente. Finalize
                                        o chat e envie uma mensagem ativa para
                                        iniciar uma nova conversa!
                                    </span>
                                </div>
                            ) : mensagemDoClienteDepoisDaMensagemEquipe ? (
                                <textarea
                                    className={`form-control border-0 p-0 y-scroll ${
                                        uploadingFileThatDoesntSupportSubtitles ||
                                        uploadingFileAudioThatDoesntSupportSubtitles
                                            ? "bg-gray-100"
                                            : ""
                                    }`}
                                    placeholder="Escreva uma mensagem..."
                                    style={{ resize: "none", height: 80 }}
                                    name="mensagem"
                                    id="mensagem-input"
                                    ref={register()}
                                    autoComplete="off"
                                    disabled={enviando}
                                    readOnly={
                                        uploadingFileThatDoesntSupportSubtitles ||
                                        uploadingFileAudioThatDoesntSupportSubtitles
                                    }
                                    onPaste={(event) => {
                                        if (
                                            !!event.clipboardData.files.item(0)
                                        ) {
                                            setFile(
                                                event.clipboardData.files.item(
                                                    0
                                                )
                                            );
                                            event.preventDefault();
                                        }
                                    }}
                                    onKeyPress={(e) => {
                                        if (e.code === "Enter" && !e.shiftKey) {
                                            e.preventDefault();
                                            handleSubmit(handleMessageSubmit)();
                                        }
                                    }}
                                />
                            ) : (
                                <textarea
                                    className={`form-control border-0 p-0 y-scroll ${
                                        uploadingFileThatDoesntSupportSubtitles ||
                                        uploadingFileAudioThatDoesntSupportSubtitles
                                            ? "bg-gray-100"
                                            : ""
                                    }`}
                                    placeholder="Escreva uma mensagem..."
                                    style={{ resize: "none", height: 80 }}
                                    name="mensagem"
                                    id="mensagem-input"
                                    ref={register()}
                                    autoComplete="off"
                                    disabled={enviando}
                                    readOnly={
                                        uploadingFileThatDoesntSupportSubtitles ||
                                        uploadingFileAudioThatDoesntSupportSubtitles
                                    }
                                    onPaste={(event) => {
                                        if (
                                            !!event.clipboardData.files.item(0)
                                        ) {
                                            setFile(
                                                event.clipboardData.files.item(
                                                    0
                                                )
                                            );
                                            event.preventDefault();
                                        }
                                    }}
                                    onKeyPress={(e) => {
                                        if (e.code === "Enter" && !e.shiftKey) {
                                            e.preventDefault();
                                            handleSubmit(handleMessageSubmit)();
                                        }
                                    }}
                                />
                            )}
                            <ClickAwayListener
                                mouseEvent="onMouseDown"
                                touchEvent="onTouchEnd"
                                onClickAway={() => {
                                    setshowMensage(false);
                                }}
                            >
                                <div
                                    className={`dropdown-column ml-2 messageShowParent ${
                                        showMensage ? "show" : ""
                                    }`}
                                >
                                    <button
                                        type="button"
                                        className="btn btn-outline-primary btn-sm"
                                        onClick={() => {
                                            setshowMensage(!showMensage);
                                        }}
                                    >
                                        <FontAwesomeIcon icon={faCommentDots} />
                                    </button>
                                    <div
                                        className={`dropdown-menu dropdown-menu-right ${
                                            showMensage
                                                ? "show mensageShow"
                                                : ""
                                        }`}
                                        aria-labelledby="dropdownMenuButton"
                                    >
                                        {lstCategoriaRespostaCompleta.map(
                                            (res) => {
                                                return (
                                                    <div
                                                        key={
                                                            res.ID_CATEGORIA_RESPOSTA_CHAT
                                                        }
                                                        className="ml-2 dropleft"
                                                    >
                                                        <button
                                                            type="button"
                                                            className="btn btn-sm"
                                                            data-toggle="dropdown"
                                                            aria-haspopup="true"
                                                            aria-expanded="false"
                                                        >
                                                            <FontAwesomeIcon
                                                                icon={
                                                                    faChevronLeft
                                                                }
                                                            />{" "}
                                                            {res
                                                                .DS_CATEGORIA_RESPOSTA_CHAT
                                                                .length > 25
                                                                ? res.DS_CATEGORIA_RESPOSTA_CHAT.substring(
                                                                      0,
                                                                      25
                                                                  ) + "..."
                                                                : res.DS_CATEGORIA_RESPOSTA_CHAT}
                                                        </button>
                                                        <div className="dropdown-menu dropdown-menu-right dropleft dropChildren">
                                                            {res.Respostas.map(
                                                                (resposta) => {
                                                                    return (
                                                                        <OverlayTrigger
                                                                            key={
                                                                                resposta.ID_RESPOSTA_CHAT
                                                                            }
                                                                            overlay={
                                                                                preencherVariaveisTemplateMensagem(
                                                                                    resposta.DS_RESPOSTA_CHAT
                                                                                )
                                                                                    .length >
                                                                                30 ? (
                                                                                    <Tooltip id="tooltip-disabled">
                                                                                        {preencherVariaveisTemplateMensagem(
                                                                                            resposta.DS_RESPOSTA_CHAT
                                                                                        )}
                                                                                    </Tooltip>
                                                                                ) : (
                                                                                    <div></div>
                                                                                )
                                                                            }
                                                                        >
                                                                            <button
                                                                                type={
                                                                                    "button"
                                                                                }
                                                                                className="dropdown-item"
                                                                                onClick={() => {
                                                                                    sendAutoMessage(
                                                                                        preencherVariaveisTemplateMensagem(
                                                                                            resposta.DS_RESPOSTA_CHAT
                                                                                        )
                                                                                    );
                                                                                }}
                                                                            >
                                                                                {preencherVariaveisTemplateMensagem(
                                                                                    resposta.DS_RESPOSTA_CHAT
                                                                                )
                                                                                    .length >
                                                                                30
                                                                                    ? preencherVariaveisTemplateMensagem(
                                                                                          resposta.DS_RESPOSTA_CHAT
                                                                                      ).substring(
                                                                                          0,
                                                                                          30
                                                                                      ) +
                                                                                      "..."
                                                                                    : preencherVariaveisTemplateMensagem(
                                                                                          resposta.DS_RESPOSTA_CHAT
                                                                                      )}
                                                                            </button>
                                                                        </OverlayTrigger>
                                                                    );
                                                                }
                                                            )}
                                                        </div>
                                                    </div>
                                                );
                                            }
                                        )}
                                    </div>
                                </div>
                            </ClickAwayListener>
                        </div>
                        <div className="d-flex align-items-center justify-content-between">
                            <div className="mr-3">
                                {file || fileAudio ? (
                                    <span
                                        className="btn btn-clean align-items-center"
                                        onClick={() => {
                                            if (file) {
                                                setFile(null);
                                            } else {
                                                setFileAudio(null);
                                            }
                                        }}
                                    >
                                        {file
                                            ? file.name.length > 20
                                                ? file.name.substring(0, 20) +
                                                  "..."
                                                : file.name
                                            : fileAudio
                                            ? fileAudio.name
                                            : ""}
                                        <FontAwesomeIcon
                                            icon={faTimes}
                                            className="text-danger ml-2"
                                        />
                                    </span>
                                ) : (
                                    <label htmlFor="file_input_send_message">
                                        <span className="btn btn-clean btn-icon btn-md">
                                            <FontAwesomeIcon
                                                icon={faPaperclip}
                                                size="lg"
                                            />
                                        </span>
                                    </label>
                                )}
                                <input
                                    type="file"
                                    name="files"
                                    id="file_input_send_message"
                                    onChange={(e) => {
                                        setFile(
                                            e.target.files
                                                ? e.target.files[0]
                                                : null
                                        );
                                    }}
                                    disabled={enviando}
                                    className="d-none"
                                    multiple={false}
                                />
                            </div>
                            <div className="d-flex">
                                {Config.ConfigAtendimentoDTO
                                    .FL_ENVIO_AUDIO_HELPDESK ? (
                                    <SimpleRecorder
                                        saveFileAudio={saveFileAudio}
                                    />
                                ) : null}
                                <button
                                    type="submit"
                                    className="btn btn-primary btn-md text-uppercase font-weight-bold chat-send py-2 px-6 ml-4"
                                    disabled={enviando}
                                >
                                    {enviando ? (
                                        <>
                                            <span
                                                className="spinner-border spinner-border-sm mr-2"
                                                role="status"
                                                aria-hidden="true"
                                            ></span>
                                            Enviando...
                                        </>
                                    ) : (
                                        "Enviar"
                                    )}
                                </button>
                            </div>
                        </div>
                    </>
                )}
            </form>
        </>
    );
}
